<template>
    <div class="mainPageDiv">

        <div class="pageHeader">
            Armed By Location Report
        </div>

        <span class="subHeaderFont">A report providing an armed count for each active
            Contract/Nationality/Company/Camp/Security Type</span>
        <p>&nbsp;</p>

        <!-- --------------------------------------------------------- -->
        <!-- ---------------- Data Grid ------------------------------ -->
        <!-- --------------------------------------------------------- -->

        <ApplicationGrid :GridData="gridTime" RowsPerPageText="Armed By Location Report"
            SearchText="Search Armed By Location Report:" :EnablePaging="false" :EnableSearching="true"
            :EnableSorting="true" :HeaderArrays="headerArrays" :RowsPerPageArray="rowsPerPageArray" :EnableSettings="false"
            :EnableRecordsInfoDisplay="true">

        </ApplicationGrid>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../../store/store.js";
import ApplicationGrid from "../../components/dataSupport/ApplicationGrid.vue"


export default {
    data() {
        return {
            store,
            gridTime: { grid: null, time: null },
            rowsPerPageArray: [10, 25, 50, 100, 250],
            headerArrays: [

                { defaultShow: true, rawName: 'contractNumber', displayName: 'Contract Number', hoverText: 'The contract number' },
                { defaultShow: true, rawName: 'conCnt', displayName: 'Contract Total', hoverText: 'Count for each nationality on the contract' },
                { defaultShow: true, rawName: 'countryName', displayName: 'Nationality', hoverText: 'Nationality' },
                { defaultShow: true, rawName: 'campName', displayName: 'Camp', hoverText: 'Camp' },
                { defaultShow: true, rawName: 'companyName', displayName: 'Company', hoverText: 'Company' },
                { defaultShow: true, rawName: 'securityTypeName', displayName: 'Security Type', hoverText: 'Security Type' }

            ],

        };
    },
    created() {
        this.getCensus();
    },
    computed: {
        UserProfileId() {
            return store.authenticatedUser.userProfileId != null
                ? store.authenticatedUser.userProfileId
                : store.tempUserProfileId;
        },
    },
    components: { ApplicationGrid },

    methods: {

        getCensus() {
            axios
                .get(store.webAPIUrl + "vwArmedByLocation")
                .then((response) => response.data)
                .then((data) => {
                    this.$data.gridTime = { grid: data, time: new Date().getTime() };
                    //console.log(data);
                });
        }
    },
};
</script>

<style scoped>
.mainPageDiv {
    margin-top: 0px;
    margin-left: 0px;
    margin-bottom: 0px;
    padding-right: 0px;
    text-align: left;
    width: 100%;
}

.subHeaderFont {
    font-size: 18px;
}

.pageHeader {
    font-size: 24px;
}
</style>
